import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { getIn } from 'formik'

import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../components/Form/Field'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { fieldValueValidator } from '../ImdPercentageFields/helpers'

import { GENDER_PERCENTAGE, genderFields, STAKEHOLDERS_LIST } from '../../../../../../stakeholdersFields'

import useStyles from '../styles'

const genderFieldsConfig = [
  { field: genderFields.female, label: 'Female\n%' },
  { field: genderFields.male, label: 'Male\n%' },
  { field: genderFields.prefer_not_to_say, label: 'Prefer not to say %' },
  { field: genderFields.other, label: 'Other\n%' },
  { field: genderFields.unknown, label: 'Unknown\n%' }
]

const GenderFields = ({ formik, index }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { errors, touched } = formik
  const path = `${STAKEHOLDERS_LIST}[${index}][${GENDER_PERCENTAGE}]`
  const genderPercentageError = getIn(errors, path)
  const genderPercentageTouched = getIn(touched, path)

  return (
    <FieldLabelWrapper label={t('Gender')}>
      <div className={classes.row}>
        {genderFieldsConfig.map(({ field, label }) => (
          <FieldLabelWrapper
            key={field}
            label={t(label)}
            className={classnames(classes.subLevelFieldWrapper, classes.ageFieldWrapper)}
            labelClassName={classes.subLevelLabel}
          >
            <Field
              className={classes.fieldInRow}
              formik={formik}
              name={`${path}[${field}]`}
              symbol={'%'}
              symbolPosition="end"
              type={'number'}
              isAllowed={fieldValueValidator}
            />
          </FieldLabelWrapper>
        ))}
      </div>
      {genderPercentageError && genderPercentageTouched && <ErrorMessage error={genderPercentageError} />}
    </FieldLabelWrapper>
  )
}

GenderFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default GenderFields
